import { useState } from "react";
import { siteNav } from "@/mocks/homeData";

export default function Header() {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");

  const goAnchor = (key: string) => {
    setOpen(false);
    document.getElementById(key)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header className="sticky top-0 z-50 border-b border-background-200 bg-background-50/85 backdrop-blur-md">
      <div className="mx-auto flex max-w-[1240px] items-center gap-4 px-4 py-3 md:px-6">
        {/* Brand */}
        <a href="#top" className="flex shrink-0 items-center gap-2" aria-label="黑料站首页">
          <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500">
            <i className="ri-flashlight-fill text-base text-background-50" aria-hidden="true" />
          </span>
          <span className="whitespace-nowrap font-heading text-lg font-bold leading-none">
            黑料站
            <span className="ml-1 hidden text-[11px] font-normal tracking-widest text-foreground-500 sm:inline">
              HEI-LIAO STATION
            </span>
          </span>
        </a>

        {/* Desktop nav */}
        <nav className="hidden flex-1 items-center justify-center gap-1 lg:flex" aria-label="主导航">
          {siteNav.map((it) => (
            <button
              key={it.key}
              onClick={() => goAnchor(it.key === "top" ? "top" : it.key)}
              className={
                it.key === "top"
                  ? "whitespace-nowrap rounded-md bg-secondary-100 px-3 py-1.5 text-sm font-medium text-foreground-950"
                  : "whitespace-nowrap rounded-md px-3 py-1.5 text-sm text-foreground-600 hover:bg-background-100 hover:text-foreground-950"
              }
            >
              {it.label}
            </button>
          ))}
        </nav>

        {/* Search */}
        <div className="ml-auto hidden items-center gap-1 rounded-full border border-background-200 bg-background-50 py-1 pl-3 pr-1 md:flex lg:ml-0">
          <i className="ri-search-line text-sm text-foreground-400" aria-hidden="true" />
          <input
            type="text"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="检索站内内容"
            aria-label="站内检索"
            className="w-32 bg-transparent text-sm text-foreground-950 outline-none placeholder:text-foreground-400 lg:w-40"
          />
          <button
            onClick={() => setQuery("")}
            className="rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50"
          >
            检索
          </button>
        </div>

        {/* Mobile toggle */}
        <button
          className="flex h-9 w-9 items-center justify-center rounded-md border border-background-200 text-foreground-700 lg:hidden"
          onClick={() => setOpen((v) => !v)}
          aria-label="展开菜单"
        >
          <i className={open ? "ri-close-line text-lg" : "ri-menu-line text-lg"} aria-hidden="true" />
        </button>
      </div>

      {/* Mobile panel */}
      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-3 lg:hidden">
          <div className="mb-3 flex items-center gap-1 rounded-full border border-background-200 px-3 py-2">
            <i className="ri-search-line text-sm text-foreground-400" aria-hidden="true" />
            <input
              type="text"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="检索站内内容"
              aria-label="站内检索"
              className="w-full bg-transparent text-sm text-foreground-950 outline-none placeholder:text-foreground-400"
            />
          </div>
          <nav className="grid grid-cols-2 gap-1" aria-label="移动导航">
            {siteNav.map((it) => (
              <button
                key={it.key}
                onClick={() => goAnchor(it.key)}
                className="flex items-center justify-between rounded-md bg-background-100 px-3 py-2.5 text-left text-sm text-foreground-800"
              >
                {it.label}
                <i className="ri-arrow-right-s-line text-foreground-400" aria-hidden="true" />
              </button>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}